/* VELISE - mobile cart sheet.
   The sheet only ever takes over below 900px. Above that, and whenever
   anything here throws or the browser has no fetch, every form and link falls
   back to the plain Shopify behaviour it had before: forms post to /cart/add,
   the cart button navigates to /cart. The one part that also runs on the
   desktop is the double-add guard further down, and all it ever does is drop
   a second add while the first one is still on its way. */
(function () {
  // Two sections reference this file, and a browser runs every <script src> it
  // is given - same URL or not. Without this guard the submit handler is bound
  // twice and every add-to-cart posts to /cart/add.js twice, so the item lands
  // in the cart twice. The flag lives on window, not in this closure, because
  // each execution gets its own closure.
  if (window.__veliseMobileCart) return;
  window.__veliseMobileCart = true;

  var MQ = '(max-width: 899.98px)';
  function mobile() {
    return window.matchMedia && window.matchMedia(MQ).matches;
  }

  var sheet, overlay, toastEl, toastTimer, lastFocus, wired;

  function $(sel, root) { return (root || document).querySelector(sel); }

  function money(cents, currency) {
    var v = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: currency || 'USD'
      }).format(v);
    } catch (e) {
      return '$' + v.toFixed(2);
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.setAttribute('data-on', 'true');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.setAttribute('data-on', 'false'); }, 2600);
  }

  function lineHtml(item, index, currency) {
    var img = item.image ? item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_140x140$1$2') : '';
    var unit = item.original_price !== item.final_price
      ? '<s>' + money(item.original_price, currency) + '</s>' + money(item.final_price, currency)
      : money(item.final_price, currency);
    var name = escapeHtml(item.product_title);

    return '' +
      '<div class="vel-sheet__line">' +
        (img ? '<img src="' + img + '" alt="" width="140" height="140" loading="lazy">' : '') +
        '<div class="vel-sheet__mid">' +
          '<p>' + name + '</p>' +
          '<p class="vel-sheet__unit">' + unit + '</p>' +
          '<div class="vel-sheet__ctl">' +
            '<div class="vel-sheet__qty">' +
              '<button type="button" data-vel-qty="' + index + '" data-vel-to="' + (item.quantity - 1) + '" aria-label="Decrease quantity of ' + name + '">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-vel-qty="' + index + '" data-vel-to="' + (item.quantity + 1) + '" aria-label="Increase quantity of ' + name + '">+</button>' +
            '</div>' +
            '<button type="button" class="vel-sheet__rm" data-vel-qty="' + index + '" data-vel-to="0">Remove</button>' +
          '</div>' +
        '</div>' +
        '<span class="vel-sheet__lt">' + money(item.final_line_price, currency) + '</span>' +
      '</div>';
  }

  function render(cart) {
    if (!sheet || !cart) return;
    var body = $('[data-vel-sheet-body]', sheet);
    var foot = $('[data-vel-sheet-foot]', sheet);
    var cur = cart.currency;
    var count = cart.item_count || 0;

    Array.prototype.forEach.call(document.querySelectorAll('[data-vel-cart-count]'), function (b) {
      b.textContent = count;
    });

    if (!count) {
      body.innerHTML = '' +
        '<div class="vel-sheet__empty">' +
          '<p>' + escapeHtml(sheet.getAttribute('data-empty-title') || 'Nothing here yet') + '</p>' +
          '<p>' + escapeHtml(sheet.getAttribute('data-empty-body') || '') + '</p>' +
          '<button type="button" class="vel-sheet__keep" data-vel-cart-close>' +
            escapeHtml(sheet.getAttribute('data-keep') || 'Keep browsing') +
          '</button>' +
        '</div>';
      foot.hidden = true;
      return;
    }

    foot.hidden = false;
    body.innerHTML = cart.items.map(function (it, i) { return lineHtml(it, i + 1, cur); }).join('');

    var saved = (cart.original_total_price || 0) - (cart.total_price || 0);
    var discRow = $('[data-vel-disc]', sheet);
    if (discRow) {
      if (saved > 0) {
        var label = (cart.cart_level_discount_applications || [])
          .map(function (d) { return d.title; }).filter(Boolean)[0];
        if (!label) {
          (cart.items || []).forEach(function (it) {
            (it.line_level_discount_allocations || []).forEach(function (a) {
              if (!label && a.discount_application) label = a.discount_application.title;
            });
          });
        }
        discRow.hidden = false;
        discRow.innerHTML = '<span>' + escapeHtml(label || 'Discount') + '</span><span>&minus;' + money(saved, cur) + '</span>';
      } else {
        discRow.hidden = true;
      }
    }

    var sum = $('[data-vel-subtotal]', sheet);
    if (sum) sum.textContent = money(cart.total_price, cur);
  }

  function getCart() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }, credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function addFromForm(form) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Accept': 'application/json' },
      credentials: 'same-origin', body: new FormData(form)
    }).then(function (r) {
      // A 200 means the item is in the cart, even if the body cannot be read.
      // Before, an unreadable body looked like a failure and invited a second
      // tap. The status travels with the error so the caller can tell
      // "Shopify said no" (4xx) from "no clear answer".
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var err = new Error(j.description || j.message || 'Add to cart failed');
          err.status = r.status;
          throw err;
        }
        return j;
      });
    });
  }

  function refresh() {
    return getCart().then(render).catch(function () {});
  }

  function open() {
    if (!sheet) return;
    lastFocus = document.activeElement;
    sheet.setAttribute('data-open', 'true');
    if (overlay) overlay.setAttribute('data-open', 'true');
    document.documentElement.style.overflow = 'hidden';
    var x = $('.vel-sheet__x', sheet);
    if (x) x.focus();
    refresh();
  }

  function close() {
    if (!sheet) return;
    sheet.setAttribute('data-open', 'false');
    if (overlay) overlay.setAttribute('data-open', 'false');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* One add at a time, on every page.

     Mobile forms marked data-vel-ajax go through fetch. Their button is
     disabled while the request runs, and a page-wide flag stops a second
     form from starting another add in the meantime.

     Every other form that posts to /cart/add (buy box, sticky bar, the
     desktop cards) is a plain browser post. The page stays clickable until
     /cart has loaded, and on a phone that easily takes a second or two. A
     second click in that window posted the same item again, and it landed
     in the cart twice. Now the first post locks the page until it is left.

     Horizon's own forms and velise-shop.js cancel the browser post before
     this listener runs (defaultPrevented), so they are left alone here. */
  var adding = false;
  var posted = false, postedBtn = null, postedTimer = 0;

  function isCartAdd(form) {
    // getAttribute, not form.action: a field named "action" would shadow it.
    return /\/cart\/add(\.js)?\/?([?#]|$)/.test(form.getAttribute('action') || '');
  }

  function releasePost() {
    clearTimeout(postedTimer);
    posted = false;
    if (postedBtn) {
      postedBtn.removeAttribute('aria-busy');
      postedBtn.style.opacity = '';
      postedBtn = null;
    }
  }

  // Back button: browsers often restore the page from memory, lock and all.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) releasePost();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.getAttribute) return;

    if (sheet && window.fetch && mobile() && form.matches('[data-vel-ajax]')) {
      e.preventDefault();
      if (adding) return;
      adding = true;
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      addFromForm(form)
        .then(function () { return refresh(); })
        .then(function () { open(); })
        .catch(function (err) {
          if (err && err.status >= 400 && err.status < 500) {
            toast(err.message || 'Could not add to cart');
            return;
          }
          // No clear answer. The item may be in the cart anyway, so do not
          // invite a second tap: show the cart as it really is.
          return getCart()
            .then(function (c) { render(c); open(); })
            .catch(function () { toast('Could not add to cart'); });
        })
        .then(function () {
          adding = false;
          if (btn) btn.disabled = false;
        });
      return;
    }

    if (e.defaultPrevented || !isCartAdd(form)) return;
    if (posted) { e.preventDefault(); return; }
    posted = true;
    postedBtn = e.submitter || form.querySelector('[type="submit"]');
    if (postedBtn) {
      postedBtn.setAttribute('aria-busy', 'true');
      postedBtn.style.opacity = '.6';
    }
    // Safety net: if the page never leaves (loading stopped by hand), the
    // buttons work again after ten seconds.
    postedTimer = setTimeout(releasePost, 10000);
  });

  function init() {
    sheet = $('[data-vel-sheet]');
    overlay = $('[data-vel-sheet-ov]');
    toastEl = $('[data-vel-toast]');
    if (!sheet) return;

    if (mobile() && window.fetch) refresh();
    if (wired) return;
    wired = true;

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;

      var openBtn = e.target.closest('[data-vel-cart-open]');
      if (openBtn && mobile() && window.fetch) { e.preventDefault(); open(); return; }

      if (e.target.closest('[data-vel-cart-close]') || e.target === overlay) { close(); return; }

      // Only the sheet's own +/- buttons. The buy box and the product section
      // use data-vel-qty as well, for their quantity field. Without this check
      // every +/- click there also sent a broken change request to the cart
      // (line 1, quantity null) and left that button disabled for good.
      var q = e.target.closest('[data-vel-qty]');
      if (q && sheet.contains(q) && q.hasAttribute('data-vel-to')) {
        var line = parseInt(q.getAttribute('data-vel-qty'), 10);
        var to = Math.max(0, parseInt(q.getAttribute('data-vel-to'), 10));
        q.disabled = true;
        changeLine(line, to).then(render).catch(function () { refresh(); });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.getAttribute('data-open') === 'true') close();
    });

    if (window.matchMedia) {
      var mql = window.matchMedia(MQ);
      var onChange = function () { if (!mobile()) close(); };
      if (mql.addEventListener) mql.addEventListener('change', onChange);
      else if (mql.addListener) mql.addListener(onChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
